var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.LoadingFlag)?_c('v-row',{attrs:{"wrap":""}},_vm._l((6),function(n){return _c('v-col',{key:n,attrs:{"cols":"12","md":"4"}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"paragraph"}},'v-skeleton-loader',_vm.attrs,false))],1)}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }